<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import subScriptionList from "./subscription-list";
    export default {
    components: { Layout, PageHeader, subScriptionList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <sub-scription-list/>
  </Layout>
</template>